
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12725',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12725",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9773",
  "foundations-components": "static-1.8150",
  "foundations-components-legacy": "static-1.1175",
  "foundations-theming": "static-1.4540",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8131",
  "hub-http-shared-msw-handlers": "static-1.10240",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11587",
  "I18n": "static-7.1637",
  "jasmine-runner": "static-1.6569",
  "marketplace-storefront-base": "static-1.12788",
  "quartz": "static-1.7168",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16796",
  "reactive-variable-buffer-atom": "static-1.2968",
  "reporting-testing-lib": "static-1.9949",
  "settings-ui-lib": "static-1.12631",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7339",
  "ui-addon-i18n": "static-1.11259",
  "ui-addon-react-router-dom": "static-1.9648",
  "unified-auth": "static-1.624",
  "unified-auth-core-lib": "static-1.906",
  "usage-tracker": "static-1.7459",
  "usage-tracker-core": "static-1.7309",
  "customer-data-property-utils": "static-1.8206",
  "hub-http": "static-1.6333",
  "integrations-lib": "static-1.16511",
  "marketplace-ui-common": "static-1.20145",
  "property-management-iframe": "static-1.13541",
  "quartz-config": "static-1.946",
  "quartz-core": "static-1.6387",
  "quartz-routing": "static-1.598",
  "quick-fetch": "static-1.3998",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4766",
  "ts-schema": "static-1.4161",
  "ui-universal-auth": "static-1.9110",
  "UIComponents": "static-3.8533",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3479",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3445",
  "quartz-webpack": "static-1.3392",
  "bend-plugin-quartz-routing": "static-1.246",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4419",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4984",
  "foundations-theming-specialty": "static-1.2256",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9533",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.35",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5422",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2188",
  "ui-fonts": "static-1.849",
  "ui-images": "static-2.1180",
  "bend-plugin-foundations-theming": "static-1.3023",
  "foundations-theming-base": "static-1.3525",
  "stylex": "static-1.34",
  "HeadJS": "static-2.768",
  "hs-test-utils-bend-plugin": "static-1.3242",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4436",
  "ai-components-ui-library": "static-1.9236",
  "ai-rendering-library": "static-1.10572",
  "chirp-fetch": "static-1.1997",
  "connections-embed-lib": "static-1.1201",
  "copilot-toolkit": "static-1.11423",
  "feedback-loader": "static-1.29507",
  "laboratory-lib": "static-3.7264",
  "marketplace-embed": "static-1.22443",
  "marketplace-ui-details": "static-1.10040",
  "marketplace-ui-reviews": "static-1.20100",
  "marketplace-ui-tracking": "static-1.14315",
  "sanitize-text": "static-1.8255",
  "ui-addon-video-player": "static-1.8813",
  "usage-tracker-multi": "static-1.5873",
  "usage-tracker-session-replay": "static-1.5145",
  "wootric-nps": "static-1.7063",
  "quartz-head": "static-1.833",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4762",
  "immer": "static-1.33",
  "immerable": "static-1.4261",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2567",
  "reporting-data": "static-1.68016",
  "cssUtils": "static-1.823",
  "flux-actions": "static-1.345",
  "HubStyle": "static-2.11894",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10318",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10473",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7449",
  "icons": "static-2.653",
  "marketplace-ui-apps-core": "static-1.18677",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4623",
  "foundations-components-test-utils": "static-1.5633",
  "quartz-i18n": "static-1.843",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.7",
  "ads-unified-auth-lib": "static-1.359",
  "google-sheets-integration-lib": "static-1.568",
  "microsoft-drive-integration-lib": "static-1.700",
  "surveymonkey-integration-lib": "static-1.27",
  "slack-ui-library": "static-1.10505",
  "fsm": "static-1.3839",
  "customer-data-objects": "static-1.7790",
  "property-translator": "static-1.5507",
  "hs-locale-management": "static-1.163",
  "frontend-preferences-client": "static-1.8038",
  "hs-promise-utils": "static-1.5702",
  "hubspot-apollo-client": "static-1.4989",
  "integrations-error-boundary-lib": "static-1.13926",
  "integrations-tracking-lib": "static-1.5717",
  "native-integrations-shared-strings": "static-1.7893",
  "reselect": "static-2.16",
  "sanitize": "static-1.4586",
  "superstore": "static-1.4870",
  "ui-shepherd-react": "static-3.10345",
  "ai-settings-ui-library": "static-1.8063",
  "hub-http-janus": "static-1.844",
  "hubspotter-http": "static-1.4732",
  "immutable-less": "static-1.4764",
  "marketplace-ui-client-types": "static-1.17552",
  "nav-meta": "static-1.29925",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18145",
  "inbound-db-properties-service-client": "static-1.3926",
  "property-management-common": "static-1.5829",
  "ui-addon-iframeable": "static-1.9178",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.543",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.843",
  "quartz-test": "static-1.843",
  "quartz-tracking": "static-1.547",
  "trellis-components": "static-1.2207",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.176",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21819",
  "ContentUtils": "static-1.68683",
  "customer-data-objects-ui-components": "static-1.13141",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2608",
  "breeze-engine-core": "static-1.385",
  "breeze-onboarding-components": "static-1.241",
  "customer-data-filters-ui": "static-1.40176",
  "customer-data-reference-ui-components": "static-1.13284",
  "embedded-academy-lib": "static-1.14728",
  "ExportDialog": "static-6.10490",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41587",
  "reporting-snowflake": "static-1.56634",
  "reporting-ui-components": "static-2.65287",
  "reporting-visualizations": "static-1.60092",
  "trellis-theming": "static-1.1052",
  "ui-addon-teams": "static-1.21694",
  "integrations-reconnect-lib": "static-1.174",
  "magpie-lib": "static-1.5624",
  "navigation-components": "static-1.18288",
  "breeze-engine-lib": "static-1.1107",
  "magpie-types": "static-1.5084",
  "simple-logging-lib": "static-1.3160",
  "ai-studio-lib": "static-1.11943",
  "app-governance-lib": "static-1.1910",
  "developer-experience-shared-components": "static-1.10625",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8118",
  "ui-product-approvals": "static-1.28594",
  "ui-tool-access": "static-1.10259",
  "usage-based-billing-components-lib": "static-1.9405",
  "usage-tracker-anonymous": "static-1.5876",
  "usage-tracker-public": "static-1.7270",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3667",
  "persist-promise": "static-1.3810",
  "reference-resolvers": "static-1.8285",
  "ui-extensibility-client-types": "static-1.4035",
  "hubspot-apollo-cache": "static-1.448",
  "universal-page-editor-lib": "static-1.3128",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3093",
  "atom": "static-1.5186",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6082",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1653",
  "crm-component-utils": "static-1.39377",
  "crm-properties-common-lib": "static-1.5999",
  "customer-data-properties": "static-1.51967",
  "framework-data-schema-resolvers": "static-1.7003",
  "property-value-citations": "static-1.2581",
  "reference-resolvers-lite": "static-1.8209",
  "ui-business-units-lib": "static-1.9177",
  "navigation-messaging": "static-1.7615",
  "hubspotter-http-shared-msw-handlers": "static-1.10238",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4926",
  "content-icons-ui": "static-1.2257",
  "customer-data-ui-utilities": "static-1.9936",
  "conversations-skeleton-state": "static-1.7358",
  "crm-message-bus": "static-1.43275",
  "customer-data-filters-ui-msw-helpers": "static-1.22611",
  "events-data-lib": "static-1.342",
  "FormUrlGenerator": "static-2.4832",
  "framework-builder-read-service-client": "static-1.4085",
  "framework-data-schema-quick-fetch": "static-1.6908",
  "multi-account-reference-resolvers": "static-1.1093",
  "onboarding-tours": "static-1.16811",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14002",
  "academy-common-lib": "static-1.14188",
  "content-assistance-lib": "static-1.7929",
  "dashboard-lib": "static-1.81961",
  "file-manager-components": "static-1.23928",
  "getting-started-shared-tasks": "static-1.18724",
  "hubspot-prosemirror": "static-1.18556",
  "hubspot-prosemirror-plugins": "static-1.18548",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20025",
  "share-with-third-party-component-lib": "static-1.8816",
  "ui-addon-draggable": "static-3.4870",
  "ui-asset-management-lib": "static-1.11175",
  "user-context": "static-1.5221",
  "growth-payments-core": "static-1.25710",
  "reporting-plugins": "static-1.10501",
  "reporting-reports": "static-1.67694",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.836",
  "nest": "static-1.343",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10738",
  "framework-listing-lib": "static-2.29010",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30976",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4365",
  "react-dnd-compat": "static-1.4726",
  "ui-product-approvals-common": "static-1.489",
  "onboarding-scopes": "static-1.6572",
  "onboarding-tours-client": "static-1.5025",
  "platform-infra-nav-components": "static-1.7753",
  "subscription-experience-data-types": "static-1.15062",
  "crm-record-cards-service-types": "static-1.3670",
  "location-customization-utils-lib": "static-1.9590",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6085",
  "signup-constants": "static-1.19111",
  "signup-ui-url-generator": "static-2.8169",
  "card-properties-lib": "static-1.44533",
  "commerce-subscription-lib": "static-1.37402",
  "crm-actions": "static-1.6450",
  "crm-cards-sdk": "static-1.43920",
  "customer-data-properties-shared-msw-handlers": "static-1.9567",
  "customer-data-tracking": "static-1.6999",
  "hs-resources": "static-1.283",
  "pulse": "static-1.707",
  "calling-global-api": "static-1.64899",
  "calling-internal-common": "static-1.31420",
  "calling-lifecycle-internal": "static-1.66281",
  "calling-lifecycle-messages": "static-1.58575",
  "commerce-products-lib": "static-1.9962",
  "conditional-properties-service-client": "static-1.3876",
  "crm-links": "static-1.6419",
  "crm-pipelines-api-client-types": "static-1.4218",
  "external-options-client-types": "static-1.4209",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4297",
  "meetings-icalendar-utils-lib": "static-1.744",
  "multi-currency-client-types": "static-1.3771",
  "object-builder-ui-client": "static-1.49133",
  "pipeline-validation-client-types": "static-1.4047",
  "smart-property-lib": "static-1.7787",
  "tiered-pricing": "static-1.1507",
  "ui-addon-form-validation": "static-1.11100",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.122",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1158",
  "growth-data-modal": "static-1.5605",
  "growth-onboarding-confetti": "static-1.3176",
  "growth-onboarding-next-action-utils": "static-1.2242",
  "onboarding-tours-utils": "static-1.877",
  "ui-shepherd-tracker": "static-1.7726",
  "academy-service-client": "static-1.3794",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39427",
  "FileManagerLib": "static-1.39568",
  "SafeStorage": "static-1.4510",
  "video-embed": "static-1.36131",
  "ui-coaching-tips": "static-1.28873",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11639",
  "video-data-lib": "static-1.35297",
  "content-media-capture": "static-1.4853",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23820",
  "ui-addon-emoji-picker": "static-1.9997",
  "EmailSignatureEditor": "static-1.24621",
  "viral-links-lib": "static-1.7181",
  "data-token-picker": "static-1.16604",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.335",
  "timezone-utils": "static-2.5354",
  "seat-types-lib": "static-1.270",
  "getting-started-shared-tasks-store": "static-1.17842",
  "ui-addon-opt": "static-4.8472",
  "campaign-roi-lib": "static-1.9425",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25667",
  "framework-data-table": "static-2.12171",
  "marketing-platform-lib": "static-1.6976",
  "nudge-client-utils": "static-1.2814",
  "nudge-custom-ui-functions": "static-1.1222",
  "switchboard-lib": "static-1.334",
  "app-users-service-client": "static-1.5718",
  "app-users-service-types": "static-1.5126",
  "mini-checkout-client": "static-1.27085",
  "onboarding-utils": "static-1.5470",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28858",
  "edison-service-client-types": "static-1.500",
  "crm_data": "static-4.92319",
  "customer-data-sidebar": "static-2.46325",
  "enrichment-properties-lib": "static-1.16905",
  "ui-addon-draggable-compat": "static-2.4370",
  "universal-record-utils-lib": "static-1.1239",
  "commerce-billing-lib": "static-1.19454",
  "commerce-shared-components-lib": "static-1.18806",
  "commerce-tools-ui-lib": "static-1.10676",
  "crm-fe-perf": "static-1.23014",
  "event-emitter": "static-1.1060",
  "bend-plugin-pulse": "static-1.210",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31427",
  "shared-worker-versioning": "static-1.11146",
  "calling-usage-tracker": "static-1.6653",
  "voice-sms-access-library": "static-1.1429",
  "commerce-permissions": "static-1.887",
  "products-iframe-lib": "static-1.8242",
  "products-ui-components-shared-msw-handlers": "static-1.10622",
  "data-agent-kit": "static-1.376",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10323",
  "policy-lib": "static-1.6892",
  "react-tinymce": "static-1.55537",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10386",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54663",
  "tinymce-plugins": "static-1.57777",
  "tinymce-themes": "static-1.56633",
  "onboarding-data-sync-lib": "static-1.2152",
  "growth-onboarding-next-action-components": "static-1.2270",
  "user-context-client": "static-1.4691",
  "audio-components": "static-1.6088",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37079",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4646",
  "video-components": "static-1.13641",
  "outpost": "static-1.4281",
  "growth-onboarding-feedback-components": "static-1.6690",
  "content-media-composition-data-lib": "static-1.12657",
  "content-media-compositions": "static-2.16664",
  "media-bridge-lib": "static-1.19119",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4535",
  "commerce-tours-lib": "static-1.6303",
  "growth-onboarding-reliability": "static-1.5191",
  "sales-checkout-service-client": "static-1.3704",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21872",
  "sales-email-signature-service-client": "static-1.3961",
  "ts-utils-lib": "static-1.283",
  "crm-export-dialog": "static-1.6395",
  "crm-index-associations-lib": "static-1.6552",
  "crm-view-components": "static-1.613",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7441",
  "nudge-custom-function-registry": "static-1.2571",
  "nudge-renderer-utils": "static-1.2890",
  "whisper-core-api": "static-1.6871",
  "InboxConnectUtils": "static-4.15105",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5796",
  "settings-content-modals": "static-1.46399",
  "crm_universal": "static-1.22204",
  "customer-data-email": "static-1.18233",
  "card-payment-highlight-lib": "static-1.37498",
  "card-subscription-highlight-lib": "static-1.39825",
  "commerce-contract-lib": "static-1.12601",
  "invoices-highlight-card-lib": "static-1.55093",
  "orders-highlight-card-lib": "static-1.21773",
  "products-highlight-card-lib": "static-1.18245",
  "quotes-highlight-card-lib": "static-1.72379",
  "crm-source-interpretation-lib": "static-1.5455",
  "crm-object-search-query-utilities": "static-1.9835",
  "utility-belt": "static-1.2643",
  "payments-enrollment-embed-lib": "static-1.23243",
  "stripe-embedded-components": "static-1.7706",
  "customer-data-rte": "static-1.33291",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5945",
  "payments-post-enroll-local-storage-lib": "static-1.5217",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38469",
  "trials-service-types": "static-1.3993",
  "calling-orchestration-schema": "static-1.36206",
  "sales-views-client-types": "static-1.4367",
  "hub-http-contrib": "static-1.3154",
  "interframe": "static-3.4871",
  "tinymce-data": "static-1.40748",
  "ui-addon-sales-email": "static-1.5320",
  "layout-dnd-components": "static-1.12660",
  "layout-dnd-utils": "static-1.11635",
  "ui-brand-identity-lib": "static-1.15683",
  "NamespacedHubStyle": "static-2.9136",
  "meetings-connect-utils-lib": "static-1.7716",
  "social-insights-client-types": "static-1.22323",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4280",
  "checkout-sdk": "static-3.23928",
  "checkout-service-types": "static-1.3878",
  "company-details-components": "static-1.6309",
  "payment-method-components": "static-1.6983",
  "pricing-pages-ui-components": "static-1.14687",
  "quote-checkout-service-types": "static-1.3576",
  "upgrade-catalog-service-types": "static-1.3632",
  "access-control-lib": "static-1.10546",
  "EmailComponents": "static-1.55079",
  "EmailData": "static-1.53756",
  "redux-less": "static-2.9594",
  "sequences-lib": "static-1.8244",
  "ui-gdpr-components": "static-1.10461",
  "products-ui-components": "static-1.40480",
  "accounting-integrations-ui-components": "static-1.7247",
  "invoices-ui-lib": "static-1.55109",
  "commerce-products-api": "static-1.2459",
  "invoices-iframe-lib": "static-1.57167",
  "quotes-modal-lib": "static-1.103057",
  "quotes-ui-lib": "static-1.81100",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28558",
  "ContentData": "static-1.68758",
  "layout-data-lib": "static-1.9960",
  "hub-http-rxjs": "static-1.809",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4048",
  "billing-payments-client-types": "static-1.4101",
  "react-performance-metrics-lib": "static-1.667",
  "account-and-billing-fintech-outages": "static-3.18716",
  "pricing-pages-api": "static-1.14552",
  "ContentComponents": "static-2.71639",
  "marketing-contacts-lib": "static-1.10419",
  "marketing-email-service-types": "static-1.1983",
  "messaging-editing-lib": "static-1.46588",
  "messaging-usage-based-billing-components-lib": "static-1.1450",
  "automation-ui-source-apps": "static-1.19209",
  "automation-ui-types": "static-1.20127",
  "messaging-types-lib": "static-1.46325",
  "onboarding-settings-client": "static-1.4614",
  "sequences-client-types-lib": "static-1.8101",
  "commerce-tax-lib": "static-1.646",
  "price-books-api": "static-1.1228",
  "price-books-components": "static-1.1286",
  "property-description-translator": "static-1.3951",
  "ramp-editor": "static-1.441",
  "commerce-analytics-service-client": "static-1.3692",
  "totals-ui-components": "static-1.23903",
  "SalesContentIndexUI": "static-3.9403",
  "advanced-menus-core": "static-1.15311",
  "advanced-menus-lib": "static-1.12224",
  "ui-memberships-settings-lib": "static-1.34343",
  "segments-query-core": "static-1.1531",
  "automation-ui-ubb": "static-1.6043",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7449",
  "data-token-views": "static-1.16585",
  "forms-utils-lib": "static-1.12791",
  "payments-embed-points-lib": "static-1.13261",
  "simple-menus-core": "static-1.15310",
  "simple-menus-lib": "static-1.16827",
  "videoconference-integration-components": "static-1.6980",
  "marketing-contacts-client": "static-1.7623",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77421",
  "short-messages-app-service-client": "static-1.4034",
  "web-interactives-components": "static-1.13956",
  "web-interactives-data": "static-1.13957",
  "messaging-shared-utils-lib": "static-1.899",
  "messaging-user-info-utils-lib": "static-1.1069",
  "email-portal-health-service-types": "static-1.1087",
  "line-items-api": "static-1.857",
  "commerce-totals-service-types": "static-1.3898",
  "FireAlarmUi": "static-1.4588",
  "sales-templates-service-types-lib": "static-1.4250",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22063",
  "automation-ui-usage-tracking": "static-1.21526",
  "data-studio-ubb": "static-1.3046",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27272",
  "collaboration-sidebar": "static-1.58173",
  "content-management-data-lib": "static-1.5600",
  "copilot-plugins": "static-1.11396",
  "cta-picker": "static-1.36695",
  "customer-agent-discovery-components-lib": "static-1.3402",
  "editor-components": "static-1.13390",
  "editor-iframe-lib": "static-1.8556",
  "error-messaging-js": "static-1.5303",
  "FormsCommonComponents": "static-1.86117",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10757",
  "SharedLegalStrings": "static-1.1857",
  "smart-content-core": "static-1.42744",
  "smart-content-lib": "static-1.43397",
  "social-composer-lib": "static-1.59555",
  "structured-content-lib": "static-1.25488",
  "theme-previewer-lib": "static-1.53549",
  "tinymce-copilot": "static-1.16731",
  "xray-recommendation-lib": "static-1.8050",
  "automation-ui-routing": "static-1.21484",
  "sql-reporting-client-types": "static-1.5726",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42438",
  "campaigns-utils-lib": "static-1.3302",
  "reporting-enablement": "static-1.23310",
  "chatspot-widget-iframe": "static-1.21810",
  "collaboration-sidebar-common": "static-1.2970",
  "forms-ai-lib": "static-1.4493",
  "codemirror-dlb": "static-1.58980",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6546",
  "report-customization-components": "static-1.13478",
  "data-quality-ui-library": "static-1.13325",
  "reporting-filters": "static-1.601",
  "reporting-insights-lib": "static-1.2076"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12725",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9773",
  "foundations-components": "/foundations-components/static-1.8150",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1175",
  "foundations-theming": "/foundations-theming/static-1.4540",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8131",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10240",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11587",
  "I18n": "/I18n/static-7.1637",
  "jasmine-runner": "/jasmine-runner/static-1.6569",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12788",
  "quartz": "/quartz/static-1.7168",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16796",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2968",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9949",
  "settings-ui-lib": "/settings-ui-lib/static-1.12631",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7339",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11259",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9648",
  "unified-auth": "/unified-auth/static-1.624",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.906",
  "usage-tracker": "/usage-tracker/static-1.7459",
  "usage-tracker-core": "/usage-tracker-core/static-1.7309",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8206",
  "hub-http": "/hub-http/static-1.6333",
  "integrations-lib": "/integrations-lib/static-1.16511",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20145",
  "property-management-iframe": "/property-management-iframe/static-1.13541",
  "quartz-config": "/quartz-config/static-1.946",
  "quartz-core": "/quartz-core/static-1.6387",
  "quartz-routing": "/quartz-routing/static-1.598",
  "quick-fetch": "/quick-fetch/static-1.3998",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4766",
  "ts-schema": "/ts-schema/static-1.4161",
  "ui-universal-auth": "/ui-universal-auth/static-1.9110",
  "UIComponents": "/UIComponents/static-3.8533",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3479",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3445",
  "quartz-webpack": "/quartz-webpack/static-1.3392",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.246",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4419",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4984",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2256",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9533",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.35",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5422",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2188",
  "ui-fonts": "/ui-fonts/static-1.849",
  "ui-images": "/ui-images/static-2.1180",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3023",
  "foundations-theming-base": "/foundations-theming-base/static-1.3525",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.768",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3242",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4436",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9236",
  "ai-rendering-library": "/ai-rendering-library/static-1.10572",
  "chirp-fetch": "/chirp-fetch/static-1.1997",
  "connections-embed-lib": "/connections-embed-lib/static-1.1201",
  "copilot-toolkit": "/copilot-toolkit/static-1.11423",
  "feedback-loader": "/feedback-loader/static-1.29507",
  "laboratory-lib": "/laboratory-lib/static-3.7264",
  "marketplace-embed": "/marketplace-embed/static-1.22443",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10040",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20100",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14315",
  "sanitize-text": "/sanitize-text/static-1.8255",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8813",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5873",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5145",
  "wootric-nps": "/wootric-nps/static-1.7063",
  "quartz-head": "/quartz-head/static-1.833",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4762",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4261",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2567",
  "reporting-data": "/reporting-data/static-1.68016",
  "cssUtils": "/cssUtils/static-1.823",
  "flux-actions": "/flux-actions/static-1.345",
  "HubStyle": "/HubStyle/static-2.11894",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10318",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10473",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7449",
  "icons": "/icons/static-2.653",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18677",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4623",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5633",
  "quartz-i18n": "/quartz-i18n/static-1.843",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.7",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.359",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.568",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.700",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.27",
  "slack-ui-library": "/slack-ui-library/static-1.10505",
  "fsm": "/fsm/static-1.3839",
  "customer-data-objects": "/customer-data-objects/static-1.7790",
  "property-translator": "/property-translator/static-1.5507",
  "hs-locale-management": "/hs-locale-management/static-1.163",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8038",
  "hs-promise-utils": "/hs-promise-utils/static-1.5702",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4989",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13926",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5717",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7893",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4586",
  "superstore": "/superstore/static-1.4870",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10345",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8063",
  "hub-http-janus": "/hub-http-janus/static-1.844",
  "hubspotter-http": "/hubspotter-http/static-1.4732",
  "immutable-less": "/immutable-less/static-1.4764",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17552",
  "nav-meta": "/nav-meta/static-1.29925",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18145",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3926",
  "property-management-common": "/property-management-common/static-1.5829",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9178",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.543",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.843",
  "quartz-test": "/quartz-test/static-1.843",
  "quartz-tracking": "/quartz-tracking/static-1.547",
  "trellis-components": "/trellis-components/static-1.2207",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.176",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21819",
  "ContentUtils": "/ContentUtils/static-1.68683",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13141",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2608",
  "breeze-engine-core": "/breeze-engine-core/static-1.385",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.241",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40176",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13284",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14728",
  "ExportDialog": "/ExportDialog/static-6.10490",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41587",
  "reporting-snowflake": "/reporting-snowflake/static-1.56634",
  "reporting-ui-components": "/reporting-ui-components/static-2.65287",
  "reporting-visualizations": "/reporting-visualizations/static-1.60092",
  "trellis-theming": "/trellis-theming/static-1.1052",
  "ui-addon-teams": "/ui-addon-teams/static-1.21694",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.174",
  "magpie-lib": "/magpie-lib/static-1.5624",
  "navigation-components": "/navigation-components/static-1.18288",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1107",
  "magpie-types": "/magpie-types/static-1.5084",
  "simple-logging-lib": "/simple-logging-lib/static-1.3160",
  "ai-studio-lib": "/ai-studio-lib/static-1.11943",
  "app-governance-lib": "/app-governance-lib/static-1.1910",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10625",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8118",
  "ui-product-approvals": "/ui-product-approvals/static-1.28594",
  "ui-tool-access": "/ui-tool-access/static-1.10259",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9405",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5876",
  "usage-tracker-public": "/usage-tracker-public/static-1.7270",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3667",
  "persist-promise": "/persist-promise/static-1.3810",
  "reference-resolvers": "/reference-resolvers/static-1.8285",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4035",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.448",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3128",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3093",
  "atom": "/atom/static-1.5186",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6082",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1653",
  "crm-component-utils": "/crm-component-utils/static-1.39377",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5999",
  "customer-data-properties": "/customer-data-properties/static-1.51967",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7003",
  "property-value-citations": "/property-value-citations/static-1.2581",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8209",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9177",
  "navigation-messaging": "/navigation-messaging/static-1.7615",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10238",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4926",
  "content-icons-ui": "/content-icons-ui/static-1.2257",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9936",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7358",
  "crm-message-bus": "/crm-message-bus/static-1.43275",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22611",
  "events-data-lib": "/events-data-lib/static-1.342",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4832",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4085",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6908",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1093",
  "onboarding-tours": "/onboarding-tours/static-1.16811",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14002",
  "academy-common-lib": "/academy-common-lib/static-1.14188",
  "content-assistance-lib": "/content-assistance-lib/static-1.7929",
  "dashboard-lib": "/dashboard-lib/static-1.81961",
  "file-manager-components": "/file-manager-components/static-1.23928",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18724",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18556",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18548",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20025",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8816",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4870",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11175",
  "user-context": "/user-context/static-1.5221",
  "growth-payments-core": "/growth-payments-core/static-1.25710",
  "reporting-plugins": "/reporting-plugins/static-1.10501",
  "reporting-reports": "/reporting-reports/static-1.67694",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.836",
  "nest": "/nest/static-1.343",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10738",
  "framework-listing-lib": "/framework-listing-lib/static-2.29010",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30976",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4365",
  "react-dnd-compat": "/react-dnd-compat/static-1.4726",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.489",
  "onboarding-scopes": "/onboarding-scopes/static-1.6572",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5025",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7753",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15062",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3670",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9590",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6085",
  "signup-constants": "/signup-constants/static-1.19111",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8169",
  "card-properties-lib": "/card-properties-lib/static-1.44533",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37402",
  "crm-actions": "/crm-actions/static-1.6450",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43920",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9567",
  "customer-data-tracking": "/customer-data-tracking/static-1.6999",
  "hs-resources": "/hs-resources/static-1.283",
  "pulse": "/pulse/static-1.707",
  "calling-global-api": "/calling-global-api/static-1.64899",
  "calling-internal-common": "/calling-internal-common/static-1.31420",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66281",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58575",
  "commerce-products-lib": "/commerce-products-lib/static-1.9962",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3876",
  "crm-links": "/crm-links/static-1.6419",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4218",
  "external-options-client-types": "/external-options-client-types/static-1.4209",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4297",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.744",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3771",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49133",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4047",
  "smart-property-lib": "/smart-property-lib/static-1.7787",
  "tiered-pricing": "/tiered-pricing/static-1.1507",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11100",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.122",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1158",
  "growth-data-modal": "/growth-data-modal/static-1.5605",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3176",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2242",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.877",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7726",
  "academy-service-client": "/academy-service-client/static-1.3794",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39427",
  "FileManagerLib": "/FileManagerLib/static-1.39568",
  "SafeStorage": "/SafeStorage/static-1.4510",
  "video-embed": "/video-embed/static-1.36131",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28873",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11639",
  "video-data-lib": "/video-data-lib/static-1.35297",
  "content-media-capture": "/content-media-capture/static-1.4853",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23820",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9997",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24621",
  "viral-links-lib": "/viral-links-lib/static-1.7181",
  "data-token-picker": "/data-token-picker/static-1.16604",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.335",
  "timezone-utils": "/timezone-utils/static-2.5354",
  "seat-types-lib": "/seat-types-lib/static-1.270",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17842",
  "ui-addon-opt": "/ui-addon-opt/static-4.8472",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9425",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25667",
  "framework-data-table": "/framework-data-table/static-2.12171",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6976",
  "nudge-client-utils": "/nudge-client-utils/static-1.2814",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1222",
  "switchboard-lib": "/switchboard-lib/static-1.334",
  "app-users-service-client": "/app-users-service-client/static-1.5718",
  "app-users-service-types": "/app-users-service-types/static-1.5126",
  "mini-checkout-client": "/mini-checkout-client/static-1.27085",
  "onboarding-utils": "/onboarding-utils/static-1.5470",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28858",
  "edison-service-client-types": "/edison-service-client-types/static-1.500",
  "crm_data": "/crm_data/static-4.92319",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46325",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16905",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4370",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1239",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19454",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18806",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10676",
  "crm-fe-perf": "/crm-fe-perf/static-1.23014",
  "event-emitter": "/event-emitter/static-1.1060",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.210",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31427",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11146",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6653",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1429",
  "commerce-permissions": "/commerce-permissions/static-1.887",
  "products-iframe-lib": "/products-iframe-lib/static-1.8242",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10622",
  "data-agent-kit": "/data-agent-kit/static-1.376",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10323",
  "policy-lib": "/policy-lib/static-1.6892",
  "react-tinymce": "/react-tinymce/static-1.55537",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10386",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54663",
  "tinymce-plugins": "/tinymce-plugins/static-1.57777",
  "tinymce-themes": "/tinymce-themes/static-1.56633",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2152",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2270",
  "user-context-client": "/user-context-client/static-1.4691",
  "audio-components": "/audio-components/static-1.6088",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37079",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4646",
  "video-components": "/video-components/static-1.13641",
  "outpost": "/outpost/static-1.4281",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6690",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12657",
  "content-media-compositions": "/content-media-compositions/static-2.16664",
  "media-bridge-lib": "/media-bridge-lib/static-1.19119",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4535",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6303",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5191",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3704",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21872",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3961",
  "ts-utils-lib": "/ts-utils-lib/static-1.283",
  "crm-export-dialog": "/crm-export-dialog/static-1.6395",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6552",
  "crm-view-components": "/crm-view-components/static-1.613",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7441",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2571",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2890",
  "whisper-core-api": "/whisper-core-api/static-1.6871",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15105",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5796",
  "settings-content-modals": "/settings-content-modals/static-1.46399",
  "crm_universal": "/crm_universal/static-1.22204",
  "customer-data-email": "/customer-data-email/static-1.18233",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37498",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39825",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12601",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55093",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21773",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18245",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72379",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5455",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9835",
  "utility-belt": "/utility-belt/static-1.2643",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23243",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7706",
  "customer-data-rte": "/customer-data-rte/static-1.33291",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5945",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5217",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38469",
  "trials-service-types": "/trials-service-types/static-1.3993",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36206",
  "sales-views-client-types": "/sales-views-client-types/static-1.4367",
  "hub-http-contrib": "/hub-http-contrib/static-1.3154",
  "interframe": "/interframe/static-3.4871",
  "tinymce-data": "/tinymce-data/static-1.40748",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5320",
  "layout-dnd-components": "/layout-dnd-components/static-1.12660",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11635",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15683",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9136",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7716",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4280",
  "checkout-sdk": "/checkout-sdk/static-3.23928",
  "checkout-service-types": "/checkout-service-types/static-1.3878",
  "company-details-components": "/company-details-components/static-1.6309",
  "payment-method-components": "/payment-method-components/static-1.6983",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14687",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3576",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3632",
  "access-control-lib": "/access-control-lib/static-1.10546",
  "EmailComponents": "/EmailComponents/static-1.55079",
  "EmailData": "/EmailData/static-1.53756",
  "redux-less": "/redux-less/static-2.9594",
  "sequences-lib": "/sequences-lib/static-1.8244",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10461",
  "products-ui-components": "/products-ui-components/static-1.40480",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7247",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55109",
  "commerce-products-api": "/commerce-products-api/static-1.2459",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57167",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103057",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81100",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28558",
  "ContentData": "/ContentData/static-1.68758",
  "layout-data-lib": "/layout-data-lib/static-1.9960",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.809",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4048",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4101",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.667",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18716",
  "pricing-pages-api": "/pricing-pages-api/static-1.14552",
  "ContentComponents": "/ContentComponents/static-2.71639",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10419",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1983",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46588",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1450",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19209",
  "automation-ui-types": "/automation-ui-types/static-1.20127",
  "messaging-types-lib": "/messaging-types-lib/static-1.46325",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4614",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8101",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.646",
  "price-books-api": "/price-books-api/static-1.1228",
  "price-books-components": "/price-books-components/static-1.1286",
  "property-description-translator": "/property-description-translator/static-1.3951",
  "ramp-editor": "/ramp-editor/static-1.441",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3692",
  "totals-ui-components": "/totals-ui-components/static-1.23903",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9403",
  "advanced-menus-core": "/advanced-menus-core/static-1.15311",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12224",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34343",
  "segments-query-core": "/segments-query-core/static-1.1531",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6043",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7449",
  "data-token-views": "/data-token-views/static-1.16585",
  "forms-utils-lib": "/forms-utils-lib/static-1.12791",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13261",
  "simple-menus-core": "/simple-menus-core/static-1.15310",
  "simple-menus-lib": "/simple-menus-lib/static-1.16827",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6980",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7623",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77421",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4034",
  "web-interactives-components": "/web-interactives-components/static-1.13956",
  "web-interactives-data": "/web-interactives-data/static-1.13957",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.899",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1069",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1087",
  "line-items-api": "/line-items-api/static-1.857",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3898",
  "FireAlarmUi": "/FireAlarmUi/static-1.4588",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4250",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22063",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21526",
  "data-studio-ubb": "/data-studio-ubb/static-1.3046",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27272",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58173",
  "content-management-data-lib": "/content-management-data-lib/static-1.5600",
  "copilot-plugins": "/copilot-plugins/static-1.11396",
  "cta-picker": "/cta-picker/static-1.36695",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3402",
  "editor-components": "/editor-components/static-1.13390",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8556",
  "error-messaging-js": "/error-messaging-js/static-1.5303",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86117",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10757",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1857",
  "smart-content-core": "/smart-content-core/static-1.42744",
  "smart-content-lib": "/smart-content-lib/static-1.43397",
  "social-composer-lib": "/social-composer-lib/static-1.59555",
  "structured-content-lib": "/structured-content-lib/static-1.25488",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53549",
  "tinymce-copilot": "/tinymce-copilot/static-1.16731",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8050",
  "automation-ui-routing": "/automation-ui-routing/static-1.21484",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5726",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42438",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3302",
  "reporting-enablement": "/reporting-enablement/static-1.23310",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21810",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2970",
  "forms-ai-lib": "/forms-ai-lib/static-1.4493",
  "codemirror-dlb": "/codemirror-dlb/static-1.58980",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6546",
  "report-customization-components": "/report-customization-components/static-1.13478",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13325",
  "reporting-filters": "/reporting-filters/static-1.601",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2076"
}
};
